import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import packageJson from '../../../../package.json';
import { ApiService } from "../../../core";


export function NavbarFooter() {
    let version = packageJson.version;
    const { t } = useTranslation('core');
    const [serverVersion, setServerVersion] = useState<string>('0.0.0');
    const api = new ApiService(process.env.REACT_APP_API);

    const fetchData = async () => {
        try {
            const serverVersionResponse = await api.get(`/version`);
            setServerVersion(serverVersionResponse);
        } catch (error) {
            console.error("Erro na requisição:", error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const NavLinkCustom = ({ to, children, ...props }) => (
        <>
            <Nav.Item className="d-none d-sm-inline">
                <Nav.Link className="text-menu-top py-1 text-capitalize0">
                    <Link to={to} style={{ textDecoration: "none", color: "black" }}>
                        {children}
                    </Link>
                </Nav.Link>
            </Nav.Item>
            {props.division &&
                <Nav.Item className="d-none d-sm-inline">
                    <Nav.Link href="/home" className="text-menu-top py-1">|</Nav.Link>
                </Nav.Item>}
        </>
    )
    return (
        <>
            <Container fluid className="pt-4 pb-3 fw-bold fs-5 bg-theme-primary mt-3" style={{ "color": "white" }}>
                <Container>
                    <p>{t('navbarFooterTitle')}<br />
                        <small className="fw-normal">{t('navbarFooterDescription')}</small>
                    </p>
                </Container>
            </Container>

            <Container className="mt-2">
                <Row>
                    <Col xs={12} sm={6} md={6} lg={5} xl={4} xxl={4}>
                        <p>{t('aboutDescription', { appName: process.env.REACT_APP_NAME })}</p>
                    </Col >
                    <Col xs={12} sm={6} md={6} lg={7} xl={8} xxl={8}>
                        <Nav className="justify-content-end">
                            <NavLinkCustom to={"/about"} division>{t('aboutTitle')}</NavLinkCustom>
                            <NavLinkCustom to={"/contact"} division>{t('contactUs')}</NavLinkCustom>
                            <NavLinkCustom to={"/faq"}>{t('faq')}</NavLinkCustom>
                        </Nav>
                    </Col>
                </Row >
            </Container >
            <Container>
                <Row>
                    <Col className="text-center mb-3" style={{ fontSize: '10px' }}>
                        v{version}.{serverVersion}
                    </Col>
                </Row>
            </Container>
        </>
    )
}